import { render, staticRenderFns } from "./MateReturnList.vue?vue&type=template&id=4d4dff92&scoped=true"
import script from "./MateReturnList.vue?vue&type=script&lang=js"
export * from "./MateReturnList.vue?vue&type=script&lang=js"
import style0 from "./MateReturnList.vue?vue&type=style&index=0&id=4d4dff92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4dff92",
  null
  
)

export default component.exports